<div class="pdf_preview_container" [class.not_ready]="!isLoaded">
  <div class="pdf_wrapper">
    <pdf-viewer [src]="pdfUrl ?? undefined" [page]="page" [render-text]="true"
      (after-load-complete)="afterLoadComplete($event)" [show-all]="false" [original-size]="true"
      [fit-to-page]="true"></pdf-viewer>
  </div>
  <div class="file_actions">
    <button type="button" class="nav_btn nav_btn_prev" (click)="prevPage()" [disabled]="page <= 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
        <path id="swipe-left" d="M15,16.59,10.673,12,15,7.41,13.668,6,8,12l5.668,6Z" transform="translate(-8 -6)" />
      </svg>
    </button>
    <span class="page_number">Page {{ page }} of {{ totalPages }}</span>
    <button type="button" class="nav_btn nav_btn_next" (click)="nextPage()" [disabled]="page >= totalPages">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
        <path id="Path_19456" data-name="Path 19456"
          d="M9.29,6.71a1,1,0,0,0,0,1.41L13.17,12,9.29,15.88a1,1,0,1,0,1.41,1.41l4.59-4.59a1,1,0,0,0,0-1.41L10.7,6.7A1,1,0,0,0,9.29,6.71Z"
          transform="translate(-8.997 -6.416)" />
      </svg>
    </button>
  </div>

</div>